import React, { FC } from 'react'
import { sumBy } from 'lodash'

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../ui/accordion'
import { Input } from '../../ui/input'

import { getFloatPrice } from '../../../helpers/price'

type Item = {
  name: string
  id: string
  cost: number
  available: number
  selectedCount: number
}

interface AddItemAccordionProps {
  name: string
  items: Item[]
  selectedItems: Item[]
  onChange: (id: string, value: number) => void
  hideRemaining?: boolean
}
export const AddItemAccordion: FC<AddItemAccordionProps> = ({
  name,
  items,
  selectedItems,
  onChange,
  hideRemaining,
}) => {
  const [isOpen, setIsOpen] = React.useState<string>(name)

  return (
    <Accordion
      type="single"
      collapsible
      className="w-full border-black/10 border px-4 rounded-xl"
      defaultValue={name}
      value={isOpen}
      onValueChange={(value) => setIsOpen(value)}
    >
      <AccordionItem value={name}>
        <AccordionTrigger>
          <div>
            <h6 className="text-base font-medium capitalize">{name}</h6>
            <p className="text-xs text-black/50 font-normal mt-1">
              {items.length} items, {getFloatPrice(sumBy(items, 'cost'))} total
            </p>
          </div>
          {!isOpen &&
            (selectedItems?.[0] ? (
              <div className="ml-auto text-xs font-normal py-1 px-2 rounded-full bg-SeabiscuitMainThemeColor/5 text-SeabiscuitMainThemeColor">
                {sumBy(selectedItems, 'selectedCount')} items,{' '}
                {getFloatPrice(
                  sumBy(selectedItems, (item) => item.cost * (item.selectedCount || 1))
                )}
              </div>
            ) : (
              <div className="ml-auto text-xs font-normal py-1 px-2 rounded-full bg-white text-black/50 border border-solid border-black/10">
                No items added
              </div>
            ))}
        </AccordionTrigger>
        <AccordionContent className="flex flex-col gap-4 text-balance">
          {items?.[0] ? (
            items.map((item) => (
              <div
                key={item.id}
                className="pt-4 border-t border-t-black/10 flex flex-wrap items-center justify-between gap-2"
              >
                <div>
                  <h6 className="text-sm font-normal">{item.name}</h6>
                  <p className="text-xs text-black/50 font-normal mt-1">
                    {getFloatPrice(item.cost)} {!hideRemaining && `• ${item.available} remaining`}
                  </p>
                </div>
                <Input
                  max={item.available}
                  value={Number(item.selectedCount) ? Number(item.selectedCount) : ''}
                  min={1}
                  type="number"
                  placeholder="Enter amount"
                  className="text-xs placeholder:text-xs w-[116px] text-center"
                  onChange={(e) => {
                    let value = Number(e.target.value)
                    if (value > Number(e.target.max) && !hideRemaining) value = Number(e.target.max)
                    onChange(item.id, value)
                  }}
                />
              </div>
            ))
          ) : (
            <p className="text-black/50 pt-4 border-t border-t-black/10">No items</p>
          )}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}
